// extracted by mini-css-extract-plugin
module.exports = {"downloadBtn":"MarkdownPreview_downloadBtn_2KXcM"};